import { LockOutlined, MobileOutlined } from '@ant-design/icons';
import { ProFormCaptcha, ProFormText } from '@ant-design/pro-components';
import PropTypes from 'prop-types';

const PhoneOtpLoginForm = ({ onGetCaptcha }) => (
  <>
    <ProFormText
      fieldProps={{
        size: 'large',
        prefix: <MobileOutlined />,
      }}
      name="phone"
      placeholder="请输入手机号！"
      rules={[
        {
          required: true,
          message: '手机号是必填项！',
        },
        {
          pattern: /^1\d{10}$/,
          message: '不合法的手机号！',
        },
      ]}
    />
    <ProFormCaptcha
      fieldProps={{
        size: 'large',
        prefix: <LockOutlined />,
      }}
      captchaProps={{
        size: 'large',
      }}
      phoneName="phone"
      placeholder="请输入验证码！"
      captchaTextRender={(timing, count) => {
        if (timing) {
          return `${count} 秒后重新获取`;
        }
        return '获取验证码';
      }}
      name="captcha"
      rules={[
        {
          required: true,
          message: '验证码是必填项！',
        },
      ]}
      onGetCaptcha={onGetCaptcha}
    />
  </>
);

PhoneOtpLoginForm.propTypes = {
  onGetCaptcha: PropTypes.func.isRequired,
};

export default PhoneOtpLoginForm;
